import React, { useEffect, useState } from "react";

const PAD = (n) => String(n).padStart(2, "0");
const DAY_PT = ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"];

/**
 * Live clock display: "Ter 15:23". Updates every 30s.
 * `compact` shows just HH:MM. Used in the CARDS layout footer and ticker right edge.
 */
export const ClockBadge = ({ compact = false, className = "", testId = "clock-badge" }) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = window.setInterval(() => setNow(new Date()), 30_000);
    return () => window.clearInterval(id);
  }, []);
  const hh = PAD(now.getHours());
  const mm = PAD(now.getMinutes());
  const day = DAY_PT[now.getDay()];
  return (
    <span className={className} data-testid={testId}>
      {compact ? `${hh}:${mm}` : `${day} ${hh}:${mm}`}
    </span>
  );
};
